import React from "react";
import styles from './ScoreBar.module.scss';
import PropTypes from "prop-types";

const ScoreBar = ({
  score = 5
}) => {
  return (
    <div className={`${styles.scoreBar} ${styles[`score-${score}`]}`}>
      <span className={`${score < 1 ? styles.disabled : ''} ${score === 1 ? styles.active : ''}`}>1</span>
      <span className={`${score < 2 ? styles.disabled : ''} ${score === 2 ? styles.active : ''}`}>2</span>
      <span className={`${score < 3 ? styles.disabled : ''} ${score === 3 ? styles.active : ''}`}>3</span>
      <span className={`${score < 4 ? styles.disabled : ''} ${score === 4 ? styles.active : ''}`}>4</span>
      <span className={`${score < 5 ? styles.disabled : ''} ${score === 5 ? styles.active : ''}`}>5</span>
    </div>
  );
};

ScoreBar.propTypes = {
  score: PropTypes.oneOf([0, 1, 2, 3, 4, 5])
}

export default ScoreBar;